import anime from 'animejs';
import { bindMethod } from 'helpers/bind';
import { EASE_OUT, frameToMs } from 'helpers/easings';
import Component from 'navigation/component/Component';
const TRANSLATE_OFFSET = 50;
export default class ImageZoomItem extends Component {
    motions = [];
    header;
    initialized() {
        super.initialized();
        this.header = this.el.getAttribute('data-header') || '';
    }
    bindEvents(add) {
        const method = bindMethod(add);
        if (this.refs.products)
            this.refs.products[method]('scroll', this.onProductScroll);
    }
    onPrev() {
        this.emit('item:prev');
    }
    onNext() {
        this.emit('item:next');
    }
    enter(direction = 1) {
        this.resize();
        const m = anime({
            begin: () => {
                this.el.classList.add('active');
                this.el.classList.add('enter');
                this.emit('item:enter', this.header);
                this.resize();
            },
            targets: this.el,
            opacity: [0, 1],
            translateX: {
                value: direction === 1 ? [TRANSLATE_OFFSET, 0] : [-TRANSLATE_OFFSET, 0],
                duration: frameToMs(25),
                easing: EASE_OUT
            },
            duration: frameToMs(25),
            easing: 'linear',
            complete: () => {
                this.el.classList.remove('enter');
                this.resize();
            }
        });
        this.motions.push(m);
    }
    leave(direction = 1) {
        const m = anime({
            begin: () => {
                this.el.classList.add('leave');
            },
            complete: () => {
                this.el.classList.remove('active');
                this.el.classList.remove('leave');
            },
            targets: this.el,
            opacity: [1, 0],
            translateX: {
                value: direction === 1 ? [0, -TRANSLATE_OFFSET] : [0, TRANSLATE_OFFSET],
                duration: frameToMs(25),
                easing: EASE_OUT
            },
            duration: frameToMs(10),
            easing: 'linear'
        });
        this.motions.push(m);
    }
    onProductScroll = () => {
        this.emit('item:toggle-nav', this.refs.products.scrollTop > 100);
    };
    reset() {
        this.el.classList.remove('active');
        this.el.classList.remove('enter');
        this.el.classList.remove('leave');
        this.el.style.opacity = '';
        this.el.style.transform = '';
        this.cancelMotions();
    }
    cancelMotions() {
        this.motions.forEach(m => m.pause());
    }
    resize() {
        super.resize();
        if (!this.refs.image)
            return;
        const offset = this.refs.image.getBoundingClientRect().height;
        if (offset > 0)
            this.parent.el.style.setProperty('--look-offset', `${offset}px`);
        // else
        //   (this.parent as any).el.style.removeProperty('--look-offset')
    }
}
